import { Button, InputGroup } from 'react-bootstrap';
import { Icon } from '../../../icon/Icon';

interface Props {
    onClick: () => void;
    show: boolean;
}

export const RangeInputGroupButton = ({ onClick, show }: Props): React.ReactElement => {
    return (
        <Button
            variant="outline-input"
            className="align-items-center text-dark"
            as={InputGroup.Append}
            onClick={onClick}
        >
            <Icon icon={show ? 'x' : 'chevron-left'}>{!show && 'Range'}</Icon>
        </Button>
    );
};
